<!-- CopyRight (C) 2017-2022 Alibaba Group Holding Limited. -->
<!-- Created by Tw93 on 17/07/28. -->

<template>

  <div class="checkbox-div" @click="wxcCellClicked">
    <weex-image :src="checkIcon" :style="checkboxImageIconStyle"></weex-image>
    <weex-text :style="checkboxTextStyle" v-html="title"></weex-text>
  </div>
 <!-- <wxc-cell :has-top-border="hasTopBorder"
            :has-bottom-border="hasBottomBorder"
            @wxcCellClicked="wxcCellClicked"
            :accessible="true"
            :has-vertical-indent="hasVerticalIndent"
            :value-on-right="checkboxOnRight"
            :aria-label="`${title},状态为${checked ? '已选中' : '未选中'},${disabled ? '不可更改' : '点击可切换'}`">
    <weex-text >:style="{color:textColor, marginLeft:textMarginLeft}"
          class="title-text"
          slot="title">{{title}}</weex-text>
    <weex-image >:src="checkIcon"
           slot="value"
           class="checkbox"></weex-image>
  </wxc-cell>-->
</template>

<style scoped>
.checkbox-div {
  display: flex;
  flex-direction: row;
}




  .title-text {
    font-size: 30px;
  }
</style>

<script>
  import WxcCell from '../wxc-cell';
  import { CHECKED, UNCHECKED, CHECKED_DISABLED, UNCHECKED_DISABLED } from './type'

  export default {
    components: { WxcCell },
    props: {
      checkboxOnRight: {
        type: Boolean,
        default: true
      },
      hasVerticalIndent: {
        type: Boolean,
        default: false
      },
      hasTopBorder: {
        type: Boolean,
        default: false
      },
      hasBottomBorder: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        require: true
      },
      value: {
        type: [String, Number, Object],
        require: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      checked: {
        type: Boolean,
        default: false
      },
      config: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      icon: [CHECKED, UNCHECKED, CHECKED_DISABLED, UNCHECKED_DISABLED],
      color: '#3D3D3D',
      innerChecked: false
    }),
    computed: {
      checkIcon() {
        const { icon, disabled, innerChecked, config } = this;
        const mergeIcon = [...icon];
        config.checkedIcon && (mergeIcon[0] = config.checkedIcon);
        config.unCheckedIcon && (mergeIcon[1] = config.unCheckedIcon);
        config.checkedDisabledIcon && (mergeIcon[2] = config.checkedDisabledIcon);
        config.unCheckedDisabledIcon && (mergeIcon[3] = config.unCheckedDisabledIcon);
        if (disabled) {
          return mergeIcon[innerChecked ? 2 : 3];
        } else {
          return mergeIcon[innerChecked ? 0 : 1];
        }
      },
      textColor() {
        const { innerChecked, disabled, config } = this;
        const checkedColor = config.checkedColor ? config.checkedColor : '#000000';
        const unCheckedColor = config.unCheckedColor ? config.unCheckedColor : '#000000';
        return innerChecked && !disabled ? checkedColor : !disabled ? unCheckedColor : '#3D3D3D';
      },

      checkboxImageIconStyle() {
        const { config } = this;
        const checkboxImageStyleFromConfig = config.iconStyle;
        return { ...{ width: "24px", height: "24px" }, ...checkboxImageStyleFromConfig }
      },

      checkboxTextStyle() {
        const { config } = this;
        const checkboxTextStyleFromConfig = config.textStyle;
        return {
          ...{ width: "100%", "margin-left": "10px", color: "black", "font-size": "12px" },
          ...checkboxTextStyleFromConfig
        }
      },
      textMarginLeft() {
        return this.checkboxOnRight ? '0px' : '18px';
      }
    },
    watch: {
      checked(newChecked) {
        this.innerChecked = newChecked;
        this.checkboxItemCheckedOrUnchecked();
      }
    },
    created() {
      const { checked } = this;
      this.innerChecked = checked;
    },
    methods: {
      wxcCellClicked() {
        const { disabled, innerChecked } = this;
        if (!disabled) {
          this.innerChecked = !innerChecked;
          this.checkboxItemCheckedOrUnchecked();
        }
      },

      checkboxItemCheckedOrUnchecked() {
        const { disabled, value } = this;
        if (!disabled) {
          this.$emit('wxcCheckBoxItemChecked', { value, checked: this.innerChecked })
        }
      }
    }
  }
</script>
